import { ref } from 'vue'

const visible = ref(false)
const text = ref('')
const color = ref('')
const timeout = ref(3000)

export function useSnackbar() {
  const showSnackbar = (newText: string, newColor = 'info', newTimeout = 3000) => {
    text.value = newText
    color.value = newColor
    timeout.value = newTimeout
    visible.value = true
  }

  return {
    visible,
    text,
    color,
    timeout,
    showSnackbar
  }
}
